const URL_TSD = 'https://villagemd.service-now.com/sp?id=sc_cat_item&sys_id=e55e279a875559101a970d4c8bbb3554&sysparm_category=030d4b33877019500dcd86ae8bbb351e';
const DOWNLOAD_IOS_APP = "https://apps.apple.com/us/app/village-medical/id1514618127";
const DOWNLOAD_ANDROID_APP = "https://play.google.com/store/apps/details?id=com.villagemd.patx&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1";

export default {
  URL_TSD,
  DOWNLOAD_IOS_APP,
  DOWNLOAD_ANDROID_APP,
};